import script from "./Confetti.vue?vue&type=script&setup=true&lang=ts"
export * from "./Confetti.vue?vue&type=script&setup=true&lang=ts"

import "./Confetti.vue?vue&type=style&index=0&id=17a32b4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a32b4a"]])

export default __exports__